import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/logos/logo3.png'


const _hoisted_1 = { class: "content d-flex justify-content-center align-items-center" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body p-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-3 mx-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    border: "0",
    alt: "",
    class: "img-fluid"
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "text-muted text-center mb-3"
}
const _hoisted_7 = {
  key: 1,
  class: "alert alert-success"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ein Rücksetzungslink für Ihr Passwort wurde an Ihre Email Adresse gesendet: ")
const _hoisted_9 = { class: "font-italic" }
const _hoisted_10 = {
  key: 2,
  class: "form-group form-group-feedback form-group-feedback-left"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "form-control-feedback" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-user text-muted" })
], -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (!_ctx.resetSuccess)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Bitte geben Sie Ihre Emailadresse ein um Ihr Passwort zurückzusetzen. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("b", _hoisted_9, _toDisplayString(_ctx.frm.email.value), 1)
              ])),
          (!_ctx.resetSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  tabindex: "1",
                  placeholder: "Emailadresse",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frm.email.value) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.frm.email.value]
                ]),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-lg btn-block",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args))),
              tabindex: "3"
            }, _toDisplayString(_ctx.resetSuccess?'Link erneut versenden':'Passwort zurücksetzen'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-lg btn-block",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backToLogin && _ctx.backToLogin(...args))),
              tabindex: "4"
            }, " Zurück zum Login ")
          ])
        ])
      ])
    ])
  ]))
}